export function delete_cookie(name) {
  if (get_cookie(name)) {
    document.cookie = `${name}=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`
  }
}

function get_cookie(name) {
  return document.cookie.split(';').some(c => {
    return c.trim().startsWith(name + '=')
  })
}
